import React, { lazy, useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import clienteAxios from '../../../configAxios/configAxios';
import './centros.css'
const { errorSwal } = lazy(() => import('../../../helper/swalHelpers'));

const reloadPage = () => {
    window.location.reload();
}

const CentrosMantencion = ({ seccion }) => {
    const [sliders, setSliders] = useState(undefined)

    const fetchSliders = async () => {
        try {
            const response = await clienteAxios.get(`sliders/modulo/${seccion}`);
            if (response.status === 200) {
                let sliders = response.data.data
                let seccion = sliders.filter((slider) => slider.Seccion === "PROMOCIONAL")

                setSliders(seccion[0]);
                return
            }
            setSliders([]);
        } catch (error) {

            errorSwal("Algo ha fallado!", "Por favor vuelve a intentarlo", "Recargar página", reloadPage)
        }
    }

    useEffect(() => {
        fetchSliders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if(!sliders) return null;
    return (
        <Container fluid>
            <Row>
                <Col className="px-0 d-none d-md-block">
                    <a href={sliders.Link} target="_blank" rel="noopener noreferrer">
                        <img data-src={sliders.Imagen} data-sizes="auto" alt="" className="lazyload w-100" />
                    </a>
                </Col>
                <Col className="px-0 d-md-none">
                    <a href={sliders.Link} target="_blank" rel="noopener noreferrer">
                        <div style={{ backgroundImage: `url(${sliders.Imagen})`, height: "1.5rem", backgroundRepeat: "no-repeat", backgroundSize: "117% 100%"}} className="w-100">
                        </div>
                    </a>
                </Col>
            </Row>
        </Container>
    );
}

export default CentrosMantencion;